// extracted by mini-css-extract-plugin
export var cardHeader = "_sy-0";
export var reorderHandle = "_sy-3";
export var titleArea = "_sy-1";
export var titleAreaWithHandle = "_sy-2";